<template>
	<Layout>
		<div class="rwt-timeline-area rn-section-gap">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<SectionTitle text-align="center" subtitle="Project Show" :title="PrjName" data-aos="fade-up"
							data-aos-delay="60" />
					</div>

					<Timeline :timeline-data="ProjectInfo" :timeline-title="PrjName"/>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
	import Layout from '../components/common/Layout'
	import SectionTitle from "../components/elements/sectionTitle/SectionTitle"
	import Timeline from "../components/elements/timeline/Timeline"

	export default {
		name: 'EdgeProjectShow',
		components: {
			Layout,
			SectionTitle,
			Timeline
		},
		data() {
			return {
				PrjName:'',
				ProjectInfo: []
			} /* end @return {type} */
		},
		/* end data(){} */
		methods: {
			getProjectData(prjID) {
				let prj='';
				let data = []
				if (prjID == '1') {
					prj='协同自动化系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统概述',
							description: '协同自动化以实现生产过程和经营业务最优化为目的。对物料、设备、工序、能源、人力等信息进行统一监控和协同管理，为企业的运行绩效进行精确度量，充分考虑成本、质量、管理、安全、配置和扩展等问题，实现产品全生命周期管理，以提升制造工厂的智能程度和工程开发效率，降低运行维护成本，方便扩展升级。',
							image: '/01_xtzdhxt/xtzdh.jpg',
							workingStep: [{
									stepTitle: '',
									stepDescription: '爱智控制协同自动化系统，以<b>现场总线</b>、<b>控制总线</b>和<b>车间级管理网络</b>的集成为基础，实现从现场级到控制级、再到工厂管理级的协同自动化。涵盖了现场设备层、控制层和管理层。<br/><b>现场设备层</b>主要解决数据采集和执行，通过现场总线网络将控制器、传感器、变送器和执行机构等连接，支持Modbus、CAN、USS、自由通信和无线ZigBee 等网络；<br/><b>控制层</b>主要包括工业PC、可编程控制器、运动控制器、专用控制装置等硬件，',
								},
								{
									stepTitle: '',
									stepDescription: '以及支持IEC61131-3 标准编程指令的程序开发软件和可实现设备管理、变量管理、画面编辑、数据管理的人机界面监控管理开发软件，支持MB + 、Profibus-DP、EtherCAT、Modbus TCP 和EPA 等网络；<br/><b>管理层</b>主要提供车间级运行管理调度，记录物料、工序、人员情况和设备运行参数，可对生产过程进行优化、诊断、维护及控制，实现企业生产管理，对制造资源进行合理规划，管理层网络连接生产设备和数据服务器，使用的网络是车间局域网和Internet。',
								},
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '系统组成',
							description: '基于爱智控制协同自动化的NEAS（Networked Enterprise Automation System）是综合了过程控制、逻辑控制、运动控制、软测量、工程组态、人机界面、监控管理和工业通信网络的企业级自动化应用，是支持用户定制其现场控制系统、批量控制系统、制造执行系统、运营管理系统和决策支持系统的统一集成架构和协同开发平台。',
							image: '/01_xtzdhxt/xtzdhzc.jpg',
							workingStep: [{
									stepTitle: '监控管理',
									stepDescription: 'DView 是一个整合了监控系统和企业管理的开发平台，真正意义上实现了从操作员监控站到企业数据中心的无缝连接。针对各制造行业数据信息的特点，软件封装了对应解决方案的开发模板，以满足用户现场监控、批量控制、生产管理、资源管理和业务流程管理的应用需求。',
								},
								{
									stepTitle: '组态编程',
									stepDescription: 'PLC_Config 是一个通用组态开发平台，遵循IEC61131-3 标准，支持梯形图、功能块、指令码编程，以网络系统中的设备为开发对象，对网络中任何一个设备进行编程。针对不同行业需求定制特殊功能块，将常用控制算法进行封装，支持运动控制仿真。',
								},
								{
									stepTitle: '可编程自动化控制',
									stepDescription: 'PAC 是满足现场应用要求的工业平板电脑，预装实时内核软件、PLC_Config编程软件、DView 监控管理开发软件，具有数控、可编程控制和人机界面等功能。',
								},
								{
									stepTitle: '测量控制',
									stepDescription: '网络化可编程控制系统是面向所有工业领域的通用控制产品，数控和机器人控制系统则强化了高速位移控制和高精度轨迹控制能力，软仪表控制系统是同时具备测量和控制功能的创新产品。三大系统均具备全分布式控制特点，可为用户量身定制，兼顾现场设备控制和数据集中汇总，为各类复杂应用提供低成本、高效能的解决方案。',
								},
								{
									stepTitle: '集成网络',
									stepDescription: '基于自主研发的高速D-BUS 总线，支持Modbus TCP、Profibus-DP、CAN、EtherCAT、USS、EPA 等主流控制层网络协议，支持Modbus、自由通信、无线ZigBee 等设备层网络协议。NEAS 不仅可以为用户提供低成本、高效能的单一化应用环境，也能够将多种架构、技术和解决方案有效地整合起来，为协同制造提供多种网络集成的开放环境。',
								}
							]
						},
						{
							id: '3',
							date: 'Part-3',
							title: '系统介绍',
							description: 'NEAS 系统提供丰富的人机界面开发模板和制造执行数据管理模板，提供集成了设备数据、视频数据和生产数据的统一开发环境，拥有强大的数据分析处理和过程优化能力，实现了产品全生命周期管理，是打造“绿色智能工厂”的支撑平台。<br/>NEAS 系统已得到广泛应用，构建了从数十点到数万点的各类控制系统，为用户解决了设备监控、车间管理、工艺改进、产线升级、系统集成等问题，实现了物料、设备和人力等企业资源的统一配置。系统提供的成套自动化解决方案为企业提高了设备运行效率和管理工作效率，降低了整体制造成本，同时在技术改造升级中满足了用户低成本、少改动的需求。',
							image: '/01_xtzdhxt/xtzdhjs.jpg',
							workingStep: [
								{
									stepTitle: '支持主流协议',
									stepDescription: 'Modbus、Profibus-DP、EtherCAT、USS、CAN、EPA、无线ZigBee',
								},
								{
									stepTitle: '全分布控制',
									stepDescription: 'Modbus、Profibus-DP、EtherCAT、USS、CAN、EPA、无线ZigBee',
								},
								{
									stepTitle: '开放性',
									stepDescription: '可与各类组态软件连接；可与各类人机界面连接；支持RS485 自由协议',
								},
								{
									stepTitle: '安全性',
									stepDescription: '光电隔离；过载保护；掉电存储；电磁兼容IEC61000-4 级；网络和设备双重冗余',
								}
							]
						},
						{
							id: '4',
							date: 'Part-4',
							title: '在众多行业中都得到广泛应用',
							description: '',
							image: '/01_xtzdhxt/xtzdhhy.jpg',
							workingStep: []
						}
						
					]
				} 
				else if (prjID == '2') {
					prj ='网络化可编程控制系统';
					data=[
						{
							id: '1',
							date: 'Part-1',
							title: '概述',
							description: '网络化可编程控制系统主要包括PEC/AIO/DIO/MEC/EDC 等系列的硬件产品，以及组态编程开发软件PLC_Config 和监控管理开发软件DView，具备全分布式控制、制造数据集中汇总管理、企业资源管理等功能，为各类复杂应用提供低成本、高效能的通用解决方案，实现工厂协同自动化。<br/> 系统支持IEC61131-3 标准的梯形图、功能块、指令码编程，具备PID 控制参数自整定等功能；支持多级从设备扩展和第三方设备接入，兼容Profibus-DP、USS、EtherCAT、Modbus、EPA 等主流控制网络协议，集成了Zigbee 无线网络，支持GPRS 模块通信；可以满足大中小型控制系统所需的通用控制需求。',
							image: '/02_wlhkbckzxt/kbckzxt.jpg',
							workingStep: [{
									stepTitle: '',
									stepDescription: '系统实现了设备管理、通信管理、变量管理、视频管理和制造执行数据管理，用XML描述方法实现对各种通信协议的支持，增加了网络支持的灵活性。<br/>系统以组态的方式进行管理信息系统开发，针对行业灵活定制，提供具有行业特色的整套开发模板，开发简易、升级和维护方便。',
								},
								{
									stepTitle: '',
									stepDescription: '系统支持网络和设备双重冗余，实现自动管理与热切换，确保了系统的可靠性与安全性。<br/>系统解决了制造工厂中多种网络集成和各层级设备集成的难题，已在钢铁、纺织、电力、水泥、医药等行业得到广泛应用，为相关企业提升了设备使用率，降低了物耗能耗，提高了运营效率，增强了综合实力。',
								},
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '系统能力',
							description: '',
							image: '/02_wlhkbckzxt/zngc.jpg',
							workingStep: [{
									stepTitle: '网络通信',
									stepDescription: '支持CAN、Modbus、Profibus-DP、USS、EtherCAT、EPA、ZigBee<br/>可基于RS485 总线自由协议与第三方设备直连<br/>高速MB + 总线速度可达1Mbps<br/>高速以太网提供微秒级响应速度<br/>支持Profibus-DP 协议的从站功能<br/>支持USS 协议的主站、从站功能',
								},
								{
									stepTitle: '组态开发',
									stepDescription: '使用IEC61131-3 标准的梯形图、功能块、指令码编程<br/>将常用行业应用封装为特殊指令，减少开发与调试时间<br/>主从设备间组态灵活方便<br/>可与各种组态软件和人机界面软件连接',
								},
								{
									stepTitle: '控制能力',
									stepDescription: '控制能力<br/>温度控制精度稳定在±0.1℃<br/>PID 控制参数自整定<br/>支持PWM 和模拟量输出<br/>支持位置式和增量式PID 控制',
								},
								{
									stepTitle: '安全性',
									stepDescription: '网络和设备的双重冗余<br/>支持以太网、串行总线、无线网络之间的异网冗余<br/>实现热切换恢复<br/>详细记录故障日志',
								},
								{
									stepTitle: '测量能力',
									stepDescription: '测量能力<br/>温度测量精度最高为±0.01℃<br/>支持多种传感器直接接入<br/>最多支持8 路混合类型传感器接入<br/>热电偶环境温度补偿精度高',
								},
								{
									stepTitle: '从设备管理',
									stepDescription: '使用串口或Zigbee 多级扩展从设备<br/>各级设备资源映射简单快捷<br/>每个模块可扩展16 个从设备',
								}
							]
						},
						{
							id: '3',
							date: 'Part-3',
							title: '系统特色',
							description: '',
							image: '/02_wlhkbckzxt/xtdszn.png',
							workingStep: [{
									stepTitle: '自由通信格式功能块（XMT，RCV）',
									stepDescription: '由于各控制器生产厂商众多，各厂家设备支持的通信协议有限，大工计控的自由通信格式功能块（XMT、RCV），可以方便的对各种不同协议的设备进行资源共享。',
								},
								{
									stepTitle: '张力测试',
									stepDescription: '大工计控可编程控制产品可通过CAN 总线，携带最多32 个张力测试仪，轻松实现每秒上百次的张力值采集，根据采集数据进行实时控制，以保证生产质量。',
								},
								{
									stepTitle: 'USS 功能块',
									stepDescription: '为了实现对变频器的灵活控制，大工计控开发了USS 协议系列功能块和USS 从站功能。用户可以通过编写简单的USS 功能块指令来控制下级的变频器，实现参数配置与读取，或直接通过USS 协议对变频器进行动作控制。同时大工计控的设备可以作为USS 从站，接收从其它设备发送过来的USS 命令报文，使用户在不改变原有控制网络总线的基础上灵活应用。',
								},
								{
									stepTitle: 'PID 控制',
									stepDescription: '大工计控可编程控制器内置了飞升曲线算法，改变了传统整定办法无法满足高精度、无超调控温需求的状况。可实现±0.1℃的高精度温度控制。提供任意速率升温、多段升温等控制程序。因此在对温度要求较高的工艺中有着绝对的优势。',
								},
								{
									stepTitle: '支持Profibus-DP 协议',
									stepDescription: '为了实现与西门子等第三方PLC 通信，大工计控支持了Profibus-DP 协议，用户可以方便地将大工计控PLC 产品作为逻辑控制或者I/O 单元接入现有控制网络，以节省系统升级成本。',
								},
								{
									stepTitle: '定制的工件检测（WPC）指令',
									stepDescription: '定制的工件检测（WPC）指令，针对生产线上的产品易丢失或易阻塞的现象进行自动检测，从而实现生产线的自动化管理，用户仅需要对工件检测指令的引脚进行简单配置即可使用，节省了针对生产线设备组态编程的开发与调试时间。',
								},
								{
									stepTitle: '严格的运行环境测试',
									stepDescription: '大工计控所有产品出厂前均需要严格地进行-40℃~85℃高低温检验，产品电磁兼容测试达到了IEC61000-4 典型工业级。',
								},
								{
									stepTitle: '经济运行（PS）指令',
									stepDescription: '经济运行（PS）指令，通过实时检测工件在生产线上的位置，对高能耗生产部件进行控制，当生产线上没有工件或工件距离较远时关闭能耗部件的运行，以达到节省能源的目的。',
								},
								{
									stepTitle: '热辊测温',
									stepDescription: '由于前纺热辊在工作中需要高速转动，普通手段无法进行温度测量，大工计控研发的热辊温度测量板，与控制器配合，轻松解决了热辊测温问题。',
								}
							]
						}
					]
				} 
				else if (prjID == '3') {
					prj ='数控和机器人控制系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '概述',
							description: '',
							image: '/03_skhjqrkzxt/skjqrxt.jpg',
							workingStep: [{
									stepTitle: '',
									stepDescription: '数控和机器人控制系统由网络化运动控制器、PAC 运动控制器和运动控制软件组成，支持IEC61131-3 标准的梯形图、功能块和指令码编程方式，提供支持PLC_Open 标准的单轴、多轴和轴组运动控制功能块指令集；支持DIN66025 标准，提供G 代码编程、调试与仿真环境；提供直线、圆弧和样条差补算法功能块，满足高精度轨迹控制需求；提供四轴并联、三轴并联、四轴串联、直角坐标四种工业机器人模型，开放机械参数配置接口，用户可根据机械设计与性能需求自行设定。',
								},
								{
									stepTitle: '',
									stepDescription: 'PAC 运动控制器预装实时内核软件，提供PLC和数控指令的实时运行环境，满足数控系统高速高精度实时控制需求，同时提供了操作系统异常保护，保证了系统运行的稳定性。<br/>自主研发的高速D-BUS 总线网络与倍福E-BUS 网络完美兼容，实现了多种网络集成环境下的多轴同步运动控制。<br/>系统适用于数控机床、起重机械、包装机械和工业机器人等对运动控制要求较高的行业。已在生产线自动上下料、拾取、搬运、码垛、电子元件焊接等工业机器人和大型起重机等高端装备中得到应用',
								},
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '运动控制介绍',
							description: '',
							image: '/03_skhjqrkzxt/ydkzdzzl.png',
							workingStep: [{
									stepTitle: '',
									stepDescription: '数控与机器人控制系统使用工业级的PAC 设备，支持Windows、Linux 等操作系统，通过自主研发的实时内核，既保留了原有操作系统的开放性，又满足了运动控制中要求的实时性。自主设计的D-BUS 总线技术通过高速环网与I/O 设备进行数据交互，辅助的MB + 总线使运动控制过程更加安全可靠。同时针对不同精度要求的控制场合，提供300KHz、500KHz 和1MHz 三个档次的高速输出产品供用户选择。',
								},
								{
									stepTitle: '',
									stepDescription: '支持PLC_Open 标准的运动控制指令集，包括单轴、多轴、轴组等运动控制功能块，可方便地实现对多种运动对象的控制。还支持根据用户配置的轨迹运行时间使用S 曲线算法动态计算加速度，使机械结构受力最小、控制过程更加稳定。以拖拽组合运动控制功能块的形式替代传统的编码工作，用户易于学习，省去大量开发时间。可以以完成对运动控制中所有控制对象的操作。',
								},
								{
									stepTitle: '',
									stepDescription: '运动控制产品支持符合DIN66025 国际标准的G 代码、M 代码。PLC_Config 编程软件支持G 代码编辑和调试，提供自动补全、语法检查与高亮、断点调试、曲线跟踪和仿真预览等多种功能，方便工程师进行G 代码编写与调试。支持G 代码与功能块、梯形图混合编程，解决了G 代码模式缺乏逻辑处理能力的难题。',
								},
								{
									stepTitle: '',
									stepDescription: '提供四种工业机器人模型：四轴并联机器人、四轴串联机器人、直角坐标机器人和三轴并联机器人模型。用户通过功能块可以方便地自定义机器人的机械部件参数。',
								},
							]
						},
						{
							id: '3',
							date: 'Part-3',
							title: '系统特色',
							description: '',
							image: '/03_skhjqrkzxt/skjqrkzxtdszn.png',
							workingStep: [{
									stepTitle: '高速总线',
									stepDescription: '微秒级环形D-BUS 高速总线<br/>1Mbps MB + 高速总线辅助网络<br/>高速MB + 总线速度可达1Mbps<br/>兼容倍福E-BUS<br/>支持多种编码器和变频器直连',
								},
								{
									stepTitle: '运动轨迹控制',
									stepDescription: '自主研发的高效实时内核调度<br/>扩展直线、圆弧、样条三种插补算法<br/>支持PLC_Open 标准的运动控制指令集<br/>支持单轴、多轴和轴组运动控制功能块',
								},
								{
									stepTitle: 'NC 控制',
									stepDescription: '支持CAD 图形文件直接转换为NC 语句<br/>支持数控功能块实现程序开发<br/>支持G 代码、M 代码编辑与调试<br/>可进行空间直线与平面圆弧加工',
								},
								{
									stepTitle: '机器人控制',
									stepDescription: '支持直角坐标系、四轴串联、四轴并联模型<br/>开放式、模型参数化配置接口<br/>高精度位置控制和速度控制',
								},
							]
						}
					]
				} 
				else if (prjID == '4') {
					prj ='软仪表控制系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '概述',
							description: '软仪表控制系统将传感器直接接入控制器，通过软件功能块实现测量、标定、校准、补偿和通信等仪表功能，包括酸碱浓度、溶氧浓度、电导率、钠离子浓度、温湿度、电流电压、功率因数等软仪表功能块指令。软仪表控制系统是测控技术领域的一大创新，使用软功能块指令和信号调理板替代了传统测量系统中的二次仪表及变送单元，大幅度降低了系统造价，维护方便。无线网络功能提高了工程布线和测量的便捷性，高速以太网通信提高了数据采集和控制的实时性和有效性。<br/>系统具备高精度仪表测量、实时控制和数据远传等功能。随着国家节能减排、低碳经济政策的推行，系统在污水处理、电力监控和供热管理等工程领域得到了广泛应用。',
							image: '/04_rybkzxt/rybkzxt.jpg',
							workingStep: []
						},
						{
							id: '2',
							date: 'Part-2',
							title: '系统特色',
							description: '',
							image: '/04_rybkzxt/rybkzxt.jpg',
							workingStep: [
								{
									stepTitle: '仪控一体化',
									stepDescription: '软仪表功能使得成本低且维护方便，无需二次仪表及变送单元<br/>内置酸碱浓度、电导率、溶氧浓度、钠离子浓度、温湿度、电流、电压、功率因数等测量功能块指令<br/>精确现场测量、实时数据传输与控制调节结合<br/>无线测量通信功能提升了工业现场的透明度和灵活性',
								},
								{
									stepTitle: '智能化',
									stepDescription: '自动计算斜率<br/>自动测量参数补偿<br/>自动测量值标定和校准<br/>自定义测量范围',
								}
							]
						}
					]
				} 
				else if (prjID == '5') {
					prj ='回流焊、波峰焊控制系统';
					data = [
						{							
							id: '1',
							date: 'Part-1',
							title: '整体设计',
							description: '回流焊、波峰焊控制系统采用以太网分布式控制器，实现多温区高精度温度控制、传送带闭环调速控制、步进电机往复运动定位控制、普通I/O 逻辑控制等，设备操作简单便捷、运行稳定可靠。',
							image: '/05_hlhkzxt/hlhkzxt.jpg',
							workingStep: [{
									stepTitle: '功能',
									stepDescription: '操作人员可实时修改设备温度、速度、PCB 宽度等相关参数',
								},
								{
									stepTitle: '指标',
									stepDescription: '控温精度超过±1℃<br/>工件自动检测识别、提示故障报警',
								},
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '系统组成',
							description: '主设备PEC8000 与扩展设备DIO3000、AIO5000 通过MB + 高速总线连接，实现I/O 毫秒级映射。<br/>PEC8000 通过标准Modbus 总线与变频器通讯，与采集的编码器高速数字量输入信号组成电机闭环反馈系统, 用于运输链速度控制<br/>DIO3000 使用高速数字量输出进行风机开关、超温报警、照明等I/O 逻辑控制<br/>AIO5000 使用自整定PID 完成多温区高精度温度控制',
							image: '/05_hlhkzxt/hlhkzxt2.jpg',
							workingStep: []
						},
						{
							id: '3',
							date: 'Part-3_1',
							title: '成果展示-1',
							description: '整套系统在回流焊、波峰焊设备上已成功应用十余万套，质量可靠、运行稳定。<br/>高精度控温能力及稳定的传送速度，提高了设备工作效率和PCB 板焊接质量。<br/>',
							image: '/05_hlhkzxt/hlhkzxt3.jpg',
							workingStep: []
						},
						{
							id: '4',
							date: 'Part-3_2',
							title: '成果展示-2',
							description: '专有指令设计无需繁琐的PLC 程序即可完成多项复杂控制功能，其中工件检测WPC 指令可自动检测工件掉板、卡板，避免运输过程中的工件损坏，经济运行PS 指令可控制设备自适应启动和停止，降低了能源消耗。',
							image: '/05_hlhkzxt/hlhkzxt4.jpg',
							workingStep: []
						}
					]
				} 
				else if (prjID == '6') {
					prj ='螺杆挤出机控制系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '螺杆挤出机是一种通过螺杆连续地定温、定量、定压将塑料熔体均匀挤出，再经冷却、定型、切割成所需塑料产品的成型设备，采用网络化可编程控制系统，使其主机传动、压力、模具温度等指标满足挤出机的各项工艺要求。',
							image: '/06_lgjcjkzxt/lgjcjkzxt.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '满足设备的转速和功率，保证设备各组件协调运行<br/>控制机筒与模具的温度、压力、流量，保证制品的质量<br/>实现整个机组的全自动集成控制',
								},
								{
									stepTitle: '系统组成',
									stepDescription: '由PAC 作为主控并实现人机交互界面功能<br/>采用以太网与MB + 高速总线完成不同网络冗余<br/>由两台PEC3000 完成开关量信号采集与控制，通过Profibus 通讯协议与AB 变频器通讯<br/>由五台PEC5000 完成对机筒、模具的温度的高精度控制',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '系统界面友好，浏览、监控等操作简便<br/>实时采集各现场控制点数据，便于操作人员及时发现并处理各种故障',
							image: '/06_lgjcjkzxt/lgjcjkzxt2.jpg',
							workingStep: []
						}
					]
				} 
				else if (prjID == '7') {
					prj ='九磨头圆钢修磨机控制系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '九磨头圆钢修磨机控制系统集光、电、机、液压控制为一体，采用PLC及伺服恒功率控制技术，可满足不同型号钢材产品的修磨需求，解决了传统圆钢修磨机结构复杂、系统精度不高、人工近距离操作存在危险等问题，自动控制代替人工控制大幅降低了系统误差，使产品质量得到提升。',
							image: '/07_jmtygxmjkzt/xmjkzxt.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '控制系统能够同时操控九台圆钢修磨机组协同作业<br/>控制系统由PLC 与人机界面组成，设备拓扑简单，可靠性高<br/>通过人机界面，操作员能够同时监测电流、速度、位置等运行指标<br/>可进行远程控制，实现操作室隔离操作，保证操作人员的安全',
								},
								{
									stepTitle: '系统组成',
									stepDescription: '使用DView 监控管理开发软件组建可视化控制界面<br/>由一台PEC3000 控制9 台圆钢修磨机的启停，同时控制辊道电机的运行<br/>由一台PEC3000 通过控制电磁阀来操作砂轮臂升降<br/>由一台PEC5000 对9 台修磨机的工作电流进行监控<br/>通过以太网与远程监控站进行通讯<br/>摄像头采用以太网连接，无需硬盘录像机',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '» 以动画的方式生动地演示了九磨头圆钢修磨机的运行过程<br/>使用电机监控，摄像头控制窗口可以任意拖放、调整，操作灵活简便<br/>大幅度提高了圆钢修磨精度，缩短了单个产品的产出时间<br/>实现了远程监控，改善了操作员的工作环境<br/>使操作人员数量减少一半，节约了企业劳动力成本',
							image: '/07_jmtygxmjkzt/xmjmix.jpg',
							workingStep: []
						}
					]
				} 
				else if (prjID == '8') {
					prj ='加弹机控制系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '加弹机是一种将POY丝等原丝加工成具有低弹和中弹性能的弹力丝的加工设备，需要对原料进行恒温控制，并对拉丝速度进行恒定控制，采用网络化可编程控制系统，完成多点高精度温度控制、拉丝恒速控制和探丝切丝控制，以及产量统计功能。',
							image: '/08_jtjkzxt/jtjkzxt.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '控制加弹机把原丝加工成具有低弹和中弹性能的弹力丝<br/>实时测量和控制加热器温度，提高产品弹力性能<br/>控制系统具备自动反馈调节功能',
								},
								{
									stepTitle: '系统组成',
									stepDescription: 'PEC3000 通过RS485 接口与触摸屏连接，用于人机交互<br/>10 路测速传感器的反馈信号接入PEC3000 的高速DI<br/>通过PLC 对各罗拉的实时速度进行监控<br/>AIO5000 用于高精度控温<br/>PEC3000/AIO5000 接口与变频器、计长器连接，控制加弹机工作<br/>实时刷新频率设定值和实时读取计时时间',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '针对纺织行业特有的工艺及技术要求，定制了整套自动化解决方案<br/>系统能够在高温、潮湿的环境下连续稳定地工作<br/>提升了罗拉转速控制和丝线加热温度控制的精度<br/>实现了从排产到切丝全过程的自动化控制与管理<br/>提高了拉伸和假捻的工艺质量<br/>已在北京、山西等地的多个纺织企业和加弹机生产企业中应用',
							image: '/08_jtjkzxt/jtjmix.jpg',
							workingStep: []
						}
					]
				} 
				else if (prjID == '9') {
					prj ='空压站控制系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '空气压缩站是由空气压缩机、空气干燥器、配套过滤器、储气罐、连接管道和阀门等设备组成的一套供气系统，其建设在冶金、电力、制药等许多大型工程中非常重要，采用网络化可编程控制系统对使用不同网络协议通信的多种设备进行协同控制，为生产过程的优化、原材料与能源的节约提供了技术支持。',
							image: '/09_kyzkzxt/kyzkzxt.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '对冷却塔、潜水泵、空气开关、空气干燥器、循环泵等设备进行监控<br/>能够与温度、压力、流量等传感器协同工作<br/>具有实时数据监视、历史数据查询、自动生成报表等功能',
								},
								{
									stepTitle: '系统组成',
									stepDescription: '控制系统由数据采集装置、设备控制装置、客户端、人机界面、打印机等组成<br/>PEC3000 用于数字信号的控制，PEC5000 用于模拟信号的采集<br/>4 台PEC3000 控制空气压缩机、冷却塔、潜水泵、高压柜、水泵、过滤机、干燥机等设备<br/>2 台PEC5000 采集循环泵、空气储罐、空气干燥机压力的温度、压力、流量等数据<br/>工控计算机接收PEC3000/PEC5000 发送的数据和人机界面请求，并生成列表<br/>打印机和人机界面输出运行状态',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '控制系统由数据采集装置、设备控制装置、客户端、人机界面、打印机等组成<br/>PEC3000 用于数字信号的控制，PEC5000 用于模拟信号的采集<br/>4 台PEC3000 控制空气压缩机、冷却塔、潜水泵、高压柜、水泵、过滤机、干燥机等设备<br/>2 台PEC5000 采集循环泵、空气储罐、空气干燥机压力的温度、压力、流量等数据<br/>工控计算机接收PEC3000/PEC5000 发送的数据和人机界面请求，并生成列表<br/>打印机和人机界面输出运行状态',
							image: '/09_kyzkzxt/kyzkzmix.jpg',
							workingStep: []
						}
					]
				}
				else if (prjID == '10') {
					prj ='并联高速拾取机器人';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '并联高速拾取机器人是用于工业、医药、食品行业中执行物品搬运、装箱等任务的工业机器人。并联高速拾取机器人控制系统集机械、电子、信息、智能控制、计算机建模等先进技术于一体，实现了对目标物品的视觉定位、抓取、搬运、旋转、摆放等操作，可对自动化流水生产线中无序或任意摆放的物品进行抓取和分拣。',
							image: '/10_blgssqjqr/bljqr.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '摄像头对目标物体进行视觉识别与精准定位<br/>运动控制定位精度小于0.1mm<br/>拾取最高速度120 件/min<br/>可视化监控界面',
								},
								{
									stepTitle: '系统组成',
									stepDescription: '机械机构由4 支主动臂，8 支从动臂以及1 个移动平台组成<br/>控制系统由PAC 控制器iTC1012、视频处理器iAC2000、高速I/O 扩展模块PEC6000、摄像头以及伺服控制器组成<br/>视频处理器iAC2000 连接摄像头，对目标物体的位置和位姿进行视觉识别与定位<br/>利用PLC_Config 编程软件开发的机器人控制程序，实现了多轴高速同步、搬运轨迹抖动抑制、高精度定位等功能<br/>同时利用DView 监控管理开发软件编写的操作界面，可以直观的展示出轨迹示教、参数设定和三维仿真的画面',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '实现了用户需求，完全替代原生产线上的进口机器人<br/>降低用户并联机器人的采购成本，提高了流水生产线中的拾取和分拣效率<br/>达到国内工业机器人的尖端水平，为医药、食品等行业提供了先进的自动化流水装配线',
							image: '/10_blgssqjqr/bljqrmix.jpg',
							workingStep: []
						}
					]
				} 
				else if (prjID == '11') {
					prj ='码垛机器人控制系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '码垛机器人是执行大批量工件、包装件的搬运、码垛、拆垛等任务的一类工业机器人,是集机械、电子、计算机、网络等技术于一体的智能机电产品。码垛机器人控制系统实现了对机械手抓取、提升、输送、放置和返回等动作的控制，并以动画形式生动显示了现场设备运行状况，操作简易。',
							image: '/11_mdjqr/dmjqr.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '四轴高速、高精度同步控制<br/>搬运轨迹平滑无抖动<br/>支持多路径优化，可为多条生产线同时码垛<br/>可通过三维动画仿真机器手动作<br/>支持示教功能，对运行轨迹进行校准<br/>高精度定位，累积误差小于2mm',
								},
								{
									stepTitle: '系统组成',
									stepDescription: '机器人由4 个主动轴与一个机械手组成，其中主动轴电机由伺服器驱动；机械手由气动夹组成，通过气泵驱动<br/>采用1 个PEC6000 完成对四轴串联机器人的控制<br/>1 个高速DO 控制伺服器的运行位置和速度，1 个DO 信号控制电机的运行方向，1 个DI 信号指示每个轴的原点<br/>4 个DI 信号连接正负限位开关与正负极限限位开关，2 个DI 和1 个DO 控制气动夹压力，2 个DI 采集来货信号<br/>利用PEC6000 的高速脉冲输入输出能力实现机器人的网络化控制<br/>机器人控制程序采用PLC_Config 编程软件开发完成，操控界面采用DView 监控管理开发软件编写',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '实现了多轴高速同步、搬运轨迹抖动抑制、高精度定位等功能<br/>实现了轨迹示教、参数设定、三维仿真等功能<br/>在仓储、物流、自动化生产线等应用中提高了工作效率，节省了人力成本',
							image: '/11_mdjqr/dmjqrmix.jpg',
							workingStep: []
						}
					]
				} 
				else if (prjID == '12') {
					prj ='智能楼宇监控系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '智能楼宇监控系统综合了计算机、网络通信和多媒体技术，实现了建筑物内电力、空调、照明、防灾、防盗、运输等设备的协同工作，促使建筑物自动化（BA）、通信自动化（CA）、办公自动化（OA）、安全保卫自动化系统（SAS）和消防自动化系统（FAS）更广泛地应用于工厂、社区、仓储物流等多种环境中。',
							image: '/12_znlyjk/znlyjkxt.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '对整座大楼进行视频监控和电力监控<br/>对楼内照明、电梯、电动门进行监控<br/>对生产线中各种设备的运行情况进行监控<br/>所有监控数据能够显示在LED 点阵屏幕或电视墙上',
								},
								{
									stepTitle: '系统组成',
									stepDescription: 'PEC8000 对7 台云台摄像头进行控制<br/>采用海康威视的硬盘录像机记录共计38 个摄像头的画面信息<br/>4 台PEC8000 分别实现用电监视、电梯监视、电动门控制的功能<br/>通过DView 监控管理开发软件实现人机界面组态功能并将监控数据输出到显示设备<br/>分别由门卫监控操作台和数据中心操作台进行操作<br/>通过以太网完成设备间通信',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '智能楼宇监控系统已在多个企事业单位成熟应用<br/>全分布式设计降低了综合布线的成本和难度<br/>系统安全性好，兼容能力强<br/>搭建了友好的监控界面，为用户预留了自定义控制参数的接口<br/>为用户节约了能源，减少了维护管理工作量和运行费用',
							image: '/05_hlhkzxt/znlyjkxtmix.jpg',
							workingStep: []
						}
					]
				} 
				else if (prjID == '13') {
					prj ='供热管网监控系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '供热管网监控系统是应用于供热管网的自动化系统，将数据通过GPRS无线网络发送至监测中心，实现数据集成，增强了数据有效性和实时性，提高了供热效率，降低了供热企业运行成本，同时减少了各换热站的长期值守人员数量，极大的降低了管理费用。',
							image: '/13_grgwjkxt/grgwjkxt.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '供热管网运行过程中需要不断采集温度、流量、压力等数据<br/>能够把分布在复杂地理情况的供热设备检测的数据传输至数据中心<br/>利用无线网络完成分布数据的集成<br/>系统具有较长的使用寿命和低廉的维护费用',
								},
								{
									stepTitle: '系统组成',
									stepDescription: '主控制器和分布控制器均使用PEC5000<br/>分布式控制器实现数据采集和设备控制<br/>主控制器串口0 通过RS485 总线与触摸屏连接，实现人机交互<br/>主控制器串口1 通过RS485 总线与GPRS DTU 无线模块连接，实现各换热站现场数据发布<br/>监测中心把各个分散的换热站数据汇总，便于工程师分析',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '实现供热管网的远程数据监控管理，大幅减少了各供热站点的值守人员数量<br/>提高了数据采集效率，增强了应急响应能力<br/>提升了供热服务质量，保障了居民冬季取暖<br/>降低了供热公司的运营成本',
							image: '/13_grgwjkxt/grgwjkxtmix.jpg',
							workingStep: []
						}
					]
				} 
				else if (prjID == '14') {
					prj ='电力数据监控系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '供热管网监控系统是应用于供热管网的自动化系统，将数据通过GPRS无线网络发送至监测中心，实现数据集成，增强了数据有效性和实时性，提高了供热效率，降低了供热企业运行成本，同时减少了各换热站的长期值守人员数量，极大的降低了管理费用。',
							image: '/14_dljkxt/dlsjjkxt.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '实时监测不同测量节点的三相电压、三相电流、功率因数<br/>电力网络监测数据集中显示<br/>自动计算电力网络传输特性参数<br/>可通过Internet 访问数据中心远程查看电力数据',
								},
								{
									stepTitle: '系统组成',
									stepDescription: '每个变电站安装一台EDC8000 和若干个电流电压调理板<br/>可编程控制器通过以太网将电力数据上传至数据中心<br/>由DView 监控管理开发软件完成人机界面组态与数据监控<br/>数据中心支持历史数据记录与查询、报表打印等功能<br/>可通过Internet 进行WEB 浏览',
								}
							]
						}
					]
				}
				else if (prjID == '15') {
					prj ='企业管理系统';
					data = [
						{
							id: '1',
							date: 'Part-1',
							title: '系统简介',
							description: '基于DView开发的企业管理系统由办公自动化系统（OA）和企业资源计划（ERP）系统两大部分组成。<br/>OA 系统侧重于企业日常事务的处理，能够使行政管理更加便捷，实现信息收发、资料汇总和行政监督。ERP 系统侧重于企业资源计划配置和业务过程集成管理，实现资源管理、运营监控和统计分析，具备支持用户自定义的流程审批模式，并附加多种辅助功能。',
							image: '/15_qyglxt/qygl.jpg',
							workingStep: [
								{
									stepTitle: '功能与指标',
									stepDescription: '实现企业内部信息交流、工作呈报、规章管理、人力资源等统一管理<br/>实现采购、生产、库房、市场、销售、研发、设备、文件的统一管理<br/>通过权限分配实现内外网访问控制和数据访问控制<br/>UI 简洁清晰、操作合理，支持B/S 和C/S 两种模式<br/>借助系统提升企业管理水平<br/>在企业内部实现无纸化办公',
								},
								{
									stepTitle: '系统组成',
									stepDescription: '界面设计、业务逻辑、数据库开发均使用DView 监控管理开发软件<br/>数据存储使用SQL Server 2000 数据库',
								}
							]
						},
						{
							id: '2',
							date: 'Part-2',
							title: '应用效果',
							description: '企业管理系统已在某制造型企业稳定运行2 年<br/>结合企业实际发展情况升级发布了3 个版本<br/>系统为客户企业保存了23000 多个事务流程信息；730 多个采购计划、450 多个生产计划；1500 多种原材料、200 多种产品、3000 多万条生产和检测档案；3200 多笔销售记录；900 多台设备详细信息<br/>系统数据统计分析功能为客户企业的供应商选取、生产工艺改进、客户评价、市场定位、新产品研发、项目立项提供了决策支持<br/>系统提高了客户企业各部门的工作效率，节省了企业运营成本<br/>系统融合了ISO9001 质量管理体系内容和CMMI 过程改进管理体系内容',
							image: '/15_qyglxt/qyglmix.jpg',
							workingStep: []
						}
					]
				}

				this.PrjName = prj;
				this.ProjectInfo = data;
			}
		},
		created() {			
			this.getProjectData(this.$route.params.caseID)
		}
	}
</script>

<style>
</style>
